import { Trans } from 'react-i18next';
import s from './index.module.scss';

const TRANS_COMPONENTS = {
  span: <span className="f-500" />,
  gain: <span className={s.gain} />,
  loss: <span className={s.loss} />,
};

const TOOLTIPS = {
  dashboard_projection: variables => (
    <Trans
      i18nKey="containers:decision_widget.tooltips_dashboard_projection"
      values={variables}
      components={TRANS_COMPONENTS}
    />
  ),
  investing_projection: variables => (
    <Trans
      i18nKey="containers:decision_widget.tooltips_investing_projection"
      values={variables}
      components={TRANS_COMPONENTS}
    />
  ),
  add_cash_projection: variables => (
    <Trans
      i18nKey="containers:decision_widget.tooltips_add_cash_projection"
      values={variables}
      components={TRANS_COMPONENTS}
    />
  ),
  withdraw_comparison: variables => (
    <Trans
      i18nKey="containers:decision_widget.tooltips_withdraw_comparison"
      values={variables}
      components={TRANS_COMPONENTS}
    />
  ),
};

const SECONDARY = {
  streak_loss_warning: variables => (
    <Trans
      i18nKey="containers:decision_widget.secondary_streak_loss_warning"
      values={variables}
      components={TRANS_COMPONENTS}
    />
  ),
};

const MESSAGES = {
  dashboard_invest_balance: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_invest_balance_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_invest_balance_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  dashboard_unlock_bonus_with_cash: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_unlock_bonus_with_cash_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_unlock_bonus_with_cash_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  dashboard_top_up_for_round: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_top_up_for_round_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_top_up_for_round_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  dashboard_unlock_bonus_top_up: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_unlock_bonus_top_up_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_dashboard_unlock_bonus_top_up_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  investing_unlock_bonus_invest: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_investing_unlock_bonus_invest_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_investing_unlock_bonus_invest_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  investing_unlock_bonus_top_up: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_investing_unlock_bonus_top_up_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_investing_unlock_bonus_top_up_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_grow: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_grow_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_grow_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_start: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_start_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_start_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_bigger: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_bigger_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_bigger_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_unlock_bonus_invest: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_unlock_bonus_invest_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_unlock_bonus_invest_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_fund_entry: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_fund_entry_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_fund_entry_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_default_unlock_bonus_top_up: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_unlock_bonus_top_up_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_default_unlock_bonus_top_up_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_live_grow: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_live_grow_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_live_grow_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  addcash_live_unlock_bonus: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_live_unlock_bonus_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_addcash_live_unlock_bonus_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  withdraw_opportunity_cost_no_round: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_opportunity_cost_no_round_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_opportunity_cost_no_round_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  withdraw_opportunity_cost_round: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_opportunity_cost_round_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_opportunity_cost_round_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
  withdraw_bonus_group_loss: variables => ({
    title: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_bonus_group_loss_title"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
    body: (
      <Trans
        i18nKey="containers:decision_widget.messages_withdraw_bonus_group_loss_body"
        values={variables}
        components={TRANS_COMPONENTS}
      />
    ),
  }),
};

export function renderTooltip(key, variables) {
  const render = TOOLTIPS[key];
  return render ? render(variables) : null;
}

export function renderSecondary(key, variables) {
  const render = SECONDARY[key];
  return render ? render(variables) : null;
}

export function renderMessage(key, variables) {
  const render = MESSAGES[key];
  if (!render) return null;
  const { title, body } = render(variables);
  return { titleNode: title, messageNode: body };
}